if (ht.CentralExchange) {
  // if an element of this class exists in the page, force a new check of messages
  ht.declare('div.SMCCheckMessages', function () {
    ht.CentralTopic('CheckMessages').publish(true);
  });
}
